import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiCore } from "Services/AuthService";

export const elementAuth = createAsyncThunk(
  'auth/elementAuth',
  async (builderConfigs) => {

    const {element, token} = builderConfigs

    const response = await apiCore(
      '/elementsAuth',
      'post',
      {element},
      {
        headers: {
          Authorization: `Bearer ${token}`
        },
        maxContentLength: Infinity,
        maxBodyLength: Infinity
      }
    )
    return response?.data
  }
)
